// Vendors
import React from 'react';

const Reply = ({
  comment_is_new,
  comment_by_builder,
  comment_date,
  comment_author,
  comment_content
}) => {
  return (
    <div
      className={`message${comment_is_new == 1 ? ' message--is-new' : ''}${
        comment_by_builder == 1 ? ' message--mine' : ''
      }`}
      style={{ marginLeft: 'auto', marginRight: 'auto' }}
    >
      <div className="message__meta">
        <h5 className="message__date">
          {comment_is_new == 1 ? (
            <span className="message__date--new">NEW — </span>
          ) : (
            ''
          )}
          {comment_date}
        </h5>
        <h5 className="message__author">
          {comment_by_builder == 1 ? comment_author : 'PERC Admin'}
        </h5>
      </div>
      <p
        className="message__content"
        dangerouslySetInnerHTML={{ __html: comment_content }}
      />
    </div>
  );
};

export default Reply;
